<template>
    <div v-cloak id="tasksWidgetMobile"  style="width:calc(33%)!important">
        <div class="tasks-trigger bg-gray-900" :class="{highlighted: open > 0}">
            <a href="#" @click.prevent="openTasks()"><i class="fa fa-check" aria-hidden="true"></i> Reminders</a>
            <span v-show="open > 0" class="widget-badge">{{ open }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                open: 0
            }
        },
        methods: {
            openTasks: function () {
                window.Bus.emit('open-reminders')
            }
        },
        mounted() {
            var that = this;

            eventBus.$on('open-tasks-calculated', function (open) {
                that.open = open
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../sass/setup';

    #tasksWidgetMobile {
        z-index: 5;
        position: relative;

        @include grid-media($mobileMenu) {
            display:inline-block;
            margin-right: 0.5em;
        }

        float: none;
        margin-right: 0;


        div.tasks-trigger {
            padding: 0.4em 1em;
            font-size: 12px;
            a {
                display: block;
                color: #FFF;
                text-decoration: none;
                .fa {
                    margin-right: 5px;
                }
                &:hover {
                    color: $yellow;
                }
                .fa.unread {
                    color: $yellow;
                }
            }

            @include mobile() {
                padding: 10px 1em 4px;
                background-color: $brand;
                text-align: center;
                font-size: 12px;

                a .fa {
                    display: block;
                    margin: 0.1em auto;
                    height: 20px;
                    font-size: 16px;
                }
                &.highlighted a{
                    color:$yellow;
                }
            }

            @include grid-media($mobileMenu) {
                border-radius: $standardBorderRadius $standardBorderRadius 0 0;

                a {
                    display: inline;
                }
            }
        }
    }

    .widget-badge{
        background-color: $yellow;
        border-radius: 50%;
        padding: 0.3em 0.5em 0.4em 0.44em;
        font-size: 9px;
        color: #000;
        font-weight: 700;
        margin-left: 7px;
        display: inline-block;
        width: 20px;
        text-align: center;
        @include mobile(){
            float: right;
            margin-top: -45px;
        }
    }
    [v-cloak] {
        display: none;
    }
</style>
